import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CountdownState {
  expireAt: number | null;
  now: number;
  intervalTime: number;
  expired: boolean;
  underOneMinute: boolean;
  formattedTimer: string;
}

const initialState: CountdownState = {
  expireAt: null,
  now: 0,
  intervalTime: 500,
  expired: false,
  underOneMinute: false,
  formattedTimer: '00:00',
};

export const countdownSlice = createSlice({
  name: 'countdown',
  initialState,
  reducers: {
    startCountdown(
      state,
      action: PayloadAction<{
        expireAt: string;
        intervalTime?: number;
      }>
    ) {
      state.expireAt = Date.parse(action.payload.expireAt);
      state.intervalTime = action.payload.intervalTime ?? 500;
      state.now = 0;
      state.expired = false;
      state.underOneMinute = false;
      state.formattedTimer = '00:00';
    },
    tick(state, action: PayloadAction<number>) {
      if (!state.expireAt) return;

      state.now = action.payload;
      const remaining = Math.max(0, state.expireAt - state.now);
      state.expired = remaining === 0;
      state.underOneMinute = remaining <= 60_999 && remaining >= 0;

      const minutes = Math.floor(remaining / 60_000);
      const seconds = Math.floor((remaining % 60_000) / 1000);
      state.formattedTimer = `${String(minutes).padStart(2, '0')}:${String(
        seconds
      ).padStart(2, '0')}`;
    },
    resetCountdown(state) {
      Object.assign(state, initialState);
    },
  },
});

export const { startCountdown, tick, resetCountdown } = countdownSlice.actions;
